module.exports = __webpack_public_path__ + "img/custom-livraison.346423e.svg";